/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * wedofi
 * A RESTful API. 🔒 Protected endpoints require authentication via secure HTTP-only cookies. Authentication is handled automatically by Better Auth after login.
 * OpenAPI spec version: 1.0.47
 */
import type {
  GetCryptoRampKycStatus200,
  GetCryptoRampKycStatus401,
  GetCryptoRampKycStatus500,
  GetCryptoRampQuoteSimulation200,
  GetCryptoRampQuoteSimulationParams,
  PostCryptoRampKycInitStream200,
  PostCryptoRampKycInitStream400,
  PostCryptoRampKycInitStream401,
  PostCryptoRampKycInitStream409,
  PostCryptoRampKycInitStream500,
  PostCryptoRampPixInitStream200,
  PostCryptoRampPixInitStream400,
  PostCryptoRampPixInitStream404,
  PostCryptoRampPixInitStream503,
  PostCryptoRampPixInitStreamBody,
  PostCryptoRampPixOfframp201,
  PostCryptoRampPixOfframp400,
  PostCryptoRampPixOfframp401,
  PostCryptoRampPixOfframp404,
  PostCryptoRampPixOfframp503,
  PostCryptoRampPixOfframpBody,
  PostCryptoRampWebhooksAvenia200,
  PostCryptoRampWebhooksAvenia400,
  PostCryptoRampWebhooksAvenia401
} from '../../models';

import { customFetch } from '../../mutator/customFetch';

/**
 * Endpoint público para receber notificações da Avenia sobre mudanças de status de tickets. Atualiza automaticamente o status das transações no banco de dados. Requer verificação de assinatura RSA-PSS no header Signature.
 * @summary Webhook da Avenia para atualização de status de tickets
 */
export type postCryptoRampWebhooksAveniaResponse200 = {
  data: PostCryptoRampWebhooksAvenia200
  status: 200
}

export type postCryptoRampWebhooksAveniaResponse400 = {
  data: PostCryptoRampWebhooksAvenia400
  status: 400
}

export type postCryptoRampWebhooksAveniaResponse401 = {
  data: PostCryptoRampWebhooksAvenia401
  status: 401
}

export type postCryptoRampWebhooksAveniaResponseSuccess = (postCryptoRampWebhooksAveniaResponse200) & {
  headers: Headers;
};
export type postCryptoRampWebhooksAveniaResponseError = (postCryptoRampWebhooksAveniaResponse400 | postCryptoRampWebhooksAveniaResponse401) & {
  headers: Headers;
};

export type postCryptoRampWebhooksAveniaResponse = (postCryptoRampWebhooksAveniaResponseSuccess | postCryptoRampWebhooksAveniaResponseError)

export const getPostCryptoRampWebhooksAveniaUrl = () => {


  

  return `https://api.wedofi.com/crypto-ramp/webhooks/avenia`
}

export const postCryptoRampWebhooksAvenia = async (postCryptoRampWebhooksAveniaBody: unknown, options?: RequestInit): Promise<postCryptoRampWebhooksAveniaResponse> => {
  
  return customFetch<postCryptoRampWebhooksAveniaResponse>(getPostCryptoRampWebhooksAveniaUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postCryptoRampWebhooksAveniaBody,)
  }
);}
  

/**
 * Simula cotação: Depósito (ON_RAMP) ou Saque (OFF_RAMP). Informe inputAmount ou outputAmount (mutuamente exclusivos). Cotação expira após alguns segundos.
 * @summary Simulação de câmbio (Depósito, Saque)
 */
export type getCryptoRampQuoteSimulationResponse200 = {
  data: GetCryptoRampQuoteSimulation200
  status: 200
}

export type getCryptoRampQuoteSimulationResponse400 = {
  data: void
  status: 400
}

export type getCryptoRampQuoteSimulationResponse500 = {
  data: void
  status: 500
}

export type getCryptoRampQuoteSimulationResponse502 = {
  data: void
  status: 502
}

export type getCryptoRampQuoteSimulationResponseSuccess = (getCryptoRampQuoteSimulationResponse200) & {
  headers: Headers;
};
export type getCryptoRampQuoteSimulationResponseError = (getCryptoRampQuoteSimulationResponse400 | getCryptoRampQuoteSimulationResponse500 | getCryptoRampQuoteSimulationResponse502) & {
  headers: Headers;
};

export type getCryptoRampQuoteSimulationResponse = (getCryptoRampQuoteSimulationResponseSuccess | getCryptoRampQuoteSimulationResponseError)

export const getGetCryptoRampQuoteSimulationUrl = (params: GetCryptoRampQuoteSimulationParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `https://api.wedofi.com/crypto-ramp/quote/simulation?${stringifiedParams}` : `https://api.wedofi.com/crypto-ramp/quote/simulation`
}

export const getCryptoRampQuoteSimulation = async (params: GetCryptoRampQuoteSimulationParams, options?: RequestInit): Promise<getCryptoRampQuoteSimulationResponse> => {
  
  return customFetch<getCryptoRampQuoteSimulationResponse>(getGetCryptoRampQuoteSimulationUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Retorna status KYC, opções de moedas/métodos de pagamento e limites operacionais da ramp para o usuário logado. Requer autenticação. Se o país não tiver ramp (ex.: PY e CO em produção), options vem com arrays vazios em onramp e offramp e limits vem null; fiatCurrency ainda é retornada quando o país está no catálogo (ex.: COP para CO).
 * @summary Status KYC da subconta do usuário na ramp
 */
export type getCryptoRampKycStatusResponse200 = {
  data: GetCryptoRampKycStatus200
  status: 200
}

export type getCryptoRampKycStatusResponse401 = {
  data: GetCryptoRampKycStatus401
  status: 401
}

export type getCryptoRampKycStatusResponse500 = {
  data: GetCryptoRampKycStatus500
  status: 500
}

export type getCryptoRampKycStatusResponseSuccess = (getCryptoRampKycStatusResponse200) & {
  headers: Headers;
};
export type getCryptoRampKycStatusResponseError = (getCryptoRampKycStatusResponse401 | getCryptoRampKycStatusResponse500) & {
  headers: Headers;
};

export type getCryptoRampKycStatusResponse = (getCryptoRampKycStatusResponseSuccess | getCryptoRampKycStatusResponseError)

export const getGetCryptoRampKycStatusUrl = () => {


  

  return `https://api.wedofi.com/crypto-ramp/kyc/status`
}

export const getCryptoRampKycStatus = async ( options?: RequestInit): Promise<getCryptoRampKycStatusResponse> => {
  
  return customFetch<getCryptoRampKycStatusResponse>(getGetCryptoRampKycStatusUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Cria subconta no provider, executa KYC shared e monitora a ativação via polling. Retorna progresso via Server-Sent Events.

**Eventos SSE:**
| Evento | Payload | Fecha stream? |
|---|---|---|
| `stream_start` | `{ providerName: string }` | Não |
| `stream_progress` | `{ progress, code, message }` | Não |
| `stream_state` | `RampSubaccountSchema` (ver abaixo) | Não |
| `stream_debug` | `{ message, attempt? }` | Não |
| `stream_end` | `{ subaccountId, message }` | Sim |
| `stream_error` | `{ message, code }` | Sim |

**Codes de progress:**
| Code | Progress | Descrição |
|---|---|---|
| `KYC_INIT_STARTED` | 0 | Processo de KYC iniciado |
| `SUBACCOUNT_CREATED` | 50 | Subconta criada no provider |
| `KYC_SHARED_COMPLETED` | 90 | KYC shared completado com sucesso |

**Codes de erro:**
| Code | Descrição |
|---|---|
| `SUBACCOUNT_ALREADY_EXISTS` | Subconta já existe para este usuário e provider |
| `KYC_SUMSUB_STEP_NOT_COMPLETED` | KYC Sumsub não foi completado |
| `PROVIDER_CREATE_SUBACCOUNT_ERROR` | Falha ao criar subconta no provider |
| `PROVIDER_INIT_KYC_SHARED_ERROR` | Falha ao iniciar KYC shared no provider |
| `KYC_SHARED_REJECTED` | KYC foi rejeitado pelo provider |
| `KYC_SHARED_STATUS_TIMEOUT` | Timeout ao aguardar ativação da subconta |

O `stream_state` emite snapshots do `RampSubaccountSchema` a cada verificação de status durante o polling de ativação.
 * @summary Iniciar onramp KYC via SSE (stream de progresso)
 */
export type postCryptoRampKycInitStreamResponse200 = {
  data: PostCryptoRampKycInitStream200
  status: 200
}

export type postCryptoRampKycInitStreamResponse400 = {
  data: PostCryptoRampKycInitStream400
  status: 400
}

export type postCryptoRampKycInitStreamResponse401 = {
  data: PostCryptoRampKycInitStream401
  status: 401
}

export type postCryptoRampKycInitStreamResponse409 = {
  data: PostCryptoRampKycInitStream409
  status: 409
}

export type postCryptoRampKycInitStreamResponse500 = {
  data: PostCryptoRampKycInitStream500
  status: 500
}

export type postCryptoRampKycInitStreamResponseSuccess = (postCryptoRampKycInitStreamResponse200) & {
  headers: Headers;
};
export type postCryptoRampKycInitStreamResponseError = (postCryptoRampKycInitStreamResponse400 | postCryptoRampKycInitStreamResponse401 | postCryptoRampKycInitStreamResponse409 | postCryptoRampKycInitStreamResponse500) & {
  headers: Headers;
};

export type postCryptoRampKycInitStreamResponse = (postCryptoRampKycInitStreamResponseSuccess | postCryptoRampKycInitStreamResponseError)

export const getPostCryptoRampKycInitStreamUrl = () => {


  

  return `https://api.wedofi.com/crypto-ramp/kyc/init/stream`
}

export const postCryptoRampKycInitStream = async ( options?: RequestInit): Promise<postCryptoRampKycInitStreamResponse> => {
  
  return customFetch<postCryptoRampKycInitStreamResponse>(getPostCryptoRampKycInitStreamUrl(),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}
  

/**
 * Recupera a cotação do cache pelo quoteId, cria o ticket PIX no provider e monitora o status da transação via SSE.

**Eventos SSE:**
| Evento | Payload | Fecha stream? |
|---|---|---|
| `stream_start` | `{ provider: string }` | Não |
| `stream_progress` | `{ progress, code, message }` | Não |
| `stream_state` | `PixTransactionStateSchema` (ver abaixo) | Não |
| `stream_end` | `PixTransactionEndSchema` (ver abaixo) | Sim |
| `stream_error` | `{ message, code }` | Sim |

**Codes de progress:**
| Code | Progress | Descrição |
|---|---|---|
| `VALIDATING_QUOTE` | 0 | Validando cotação no cache |
| `CHECKING_SUBACCOUNT` | 10 | Verificando subconta |
| `CREATING_TICKET` | 20 | Criando ticket PIX no provider |
| `SAVING_TRANSACTION` | 30 | Persistindo transação |
| `PIX_CREATED` | 40 | PIX gerado, aguardando pagamento |

Após `PIX_CREATED`, o stream entra em modo long-lived e monitora o status da transação no banco a cada 5s.
O `stream_state` é emitido a cada mudança de status. O stream fecha automaticamente em status terminal ou por timeout (3 min).
 * @summary Iniciar transação PIX via SSE (BRL → crypto)
 */
export type postCryptoRampPixInitStreamResponse200 = {
  data: PostCryptoRampPixInitStream200
  status: 200
}

export type postCryptoRampPixInitStreamResponse400 = {
  data: PostCryptoRampPixInitStream400
  status: 400
}

export type postCryptoRampPixInitStreamResponse404 = {
  data: PostCryptoRampPixInitStream404
  status: 404
}

export type postCryptoRampPixInitStreamResponse503 = {
  data: PostCryptoRampPixInitStream503
  status: 503
}

export type postCryptoRampPixInitStreamResponseSuccess = (postCryptoRampPixInitStreamResponse200) & {
  headers: Headers;
};
export type postCryptoRampPixInitStreamResponseError = (postCryptoRampPixInitStreamResponse400 | postCryptoRampPixInitStreamResponse404 | postCryptoRampPixInitStreamResponse503) & {
  headers: Headers;
};

export type postCryptoRampPixInitStreamResponse = (postCryptoRampPixInitStreamResponseSuccess | postCryptoRampPixInitStreamResponseError)

export const getPostCryptoRampPixInitStreamUrl = () => {


  

  return `https://api.wedofi.com/crypto-ramp/pix/init/stream`
}

export const postCryptoRampPixInitStream = async (postCryptoRampPixInitStreamBody: PostCryptoRampPixInitStreamBody, options?: RequestInit): Promise<postCryptoRampPixInitStreamResponse> => {
  
  return customFetch<postCryptoRampPixInitStreamResponse>(getPostCryptoRampPixInitStreamUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postCryptoRampPixInitStreamBody,)
  }
);}
  

/**
 * Recupera a cotação de off-ramp pelo quoteId (cache), resolve o beneficiário PIX do usuário e cria o ticket no provider. Síncrono (sem stream). O status posterior é atualizado via webhook.
 * @summary Confirmar off-ramp (USDT → BRL via PIX)
 */
export type postCryptoRampPixOfframpResponse201 = {
  data: PostCryptoRampPixOfframp201
  status: 201
}

export type postCryptoRampPixOfframpResponse400 = {
  data: PostCryptoRampPixOfframp400
  status: 400
}

export type postCryptoRampPixOfframpResponse401 = {
  data: PostCryptoRampPixOfframp401
  status: 401
}

export type postCryptoRampPixOfframpResponse404 = {
  data: PostCryptoRampPixOfframp404
  status: 404
}

export type postCryptoRampPixOfframpResponse503 = {
  data: PostCryptoRampPixOfframp503
  status: 503
}

export type postCryptoRampPixOfframpResponseSuccess = (postCryptoRampPixOfframpResponse201) & {
  headers: Headers;
};
export type postCryptoRampPixOfframpResponseError = (postCryptoRampPixOfframpResponse400 | postCryptoRampPixOfframpResponse401 | postCryptoRampPixOfframpResponse404 | postCryptoRampPixOfframpResponse503) & {
  headers: Headers;
};

export type postCryptoRampPixOfframpResponse = (postCryptoRampPixOfframpResponseSuccess | postCryptoRampPixOfframpResponseError)

export const getPostCryptoRampPixOfframpUrl = () => {


  

  return `https://api.wedofi.com/crypto-ramp/pix/offramp`
}

export const postCryptoRampPixOfframp = async (postCryptoRampPixOfframpBody: PostCryptoRampPixOfframpBody, options?: RequestInit): Promise<postCryptoRampPixOfframpResponse> => {
  
  return customFetch<postCryptoRampPixOfframpResponse>(getPostCryptoRampPixOfframpUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postCryptoRampPixOfframpBody,)
  }
);}
  

